import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonChatButtonComponent } from './shared/components/common-chat-button/common-chat-button.component';
import { CookieConsentBannerComponent } from './shared/components/cookie-consent-banner/cookie-consent-banner.component';
import { InactivityWarningComponent } from './shared/components/inactivity-warning/inactivity-warning.component';
import { UserService } from './services/user/user.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    CommonChatButtonComponent,
    InactivityWarningComponent,
    CookieConsentBannerComponent,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements AfterViewInit {
  private readonly el = inject(ElementRef);
  private readonly userService = inject(UserService);

  readonly isAuthenticated = this.userService.userRoleGate;

  ngAfterViewInit(): void {
    this.el.nativeElement.removeAttribute('ng-version');
  }
}
